import { cn } from '../../lib/cn';

// Скелетон вместо слова «Загрузка…»: показывает форму того, что сейчас появится, и не
// заставляет читать текст, который через секунду исчезнет.

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-md bg-panel2', className)} aria-hidden />;
}

/** Несколько строк-заглушек: список, таблица, лента. */
export function SkeletonRows({ rows = 3, className }: { rows?: number; className?: string }) {
  return (
    <div className={cn('flex flex-col gap-2 p-4', className)} role="status" aria-label="Загрузка">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="h-12 w-full" />
      ))}
    </div>
  );
}
